import { useEffect, useRef } from "react";

function useFirstMountState(): boolean {
	const isFirst = useRef(true);

	if (isFirst.current) {
		isFirst.current = false;

		return true;
	}

	return isFirst.current;
}

/**
 * @see {@link(https://github.com/streamich/react-use/blob/master/docs/useUpdateEffect.md)}
 * @param effect
 * @param deps
 */
const useUpdateEffect: typeof useEffect = (effect, deps) => {
	const isFirstMount = useFirstMountState();

	useEffect(() => {
		if (!isFirstMount) {
			return effect();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
};

export default useUpdateEffect;
